import { render, staticRenderFns } from "./stuTrain.vue?vue&type=template&id=3c852e8e"
import script from "./stuTrain.vue?vue&type=script&lang=js"
export * from "./stuTrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports